export const data = [
    { label: "Home", link: "/" },
    { label: "Users", link: "/users" },
    { label: "News", link: "/news" },
    { label: "Projects", link: "/projects" },
];
